import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VContainer,
    [
      _c(
        VRow,
        { staticClass: "text-center" },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _vm.logsList.length
                ? _c(VDataTable, {
                    attrs: { headers: _vm.headers, items: _vm.logsList },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.description",
                          fn: function (row) {
                            return [
                              row.item.type === "ACCESS"
                                ? [
                                    _c("span", [_vm._v("Generated view:")]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: row.item.description.value,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s("Click to view"))]
                                    ),
                                  ]
                                : _vm._e(),
                              row.item.type === "ACCESS"
                                ? [
                                    _c(
                                      "b-table-simple",
                                      {
                                        attrs: {
                                          small: true,
                                          "sticky-header": "",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-thead",
                                          [
                                            _c(
                                              "b-tr",
                                              [
                                                _c("b-th", [
                                                  _vm._v("Benefited "),
                                                ]),
                                                _c("b-th", [
                                                  _vm._v("End Date "),
                                                ]),
                                                _c("b-th", [_vm._v("View ")]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-tbody",
                                          _vm._l(
                                            row.item.description.changes,
                                            function (item2) {
                                              return _c(
                                                "b-tr",
                                                [
                                                  _c("b-td", [
                                                    _vm._v(
                                                      _vm._s(item2.benefited)
                                                    ),
                                                  ]),
                                                  _c("b-td", [
                                                    _vm._v(
                                                      _vm._s(item2.end_date)
                                                    ),
                                                  ]),
                                                  _c("b-td", [
                                                    _vm._v(_vm._s(item2.view)),
                                                  ]),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : row.item.description.changes.length > 0
                                ? _c("table-log-detail", {
                                    attrs: {
                                      items: row.item.description.changes,
                                    },
                                  })
                                : _c("span", [_vm._v("No changes detected")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1654245277
                    ),
                  })
                : _c("p", [_vm._v(_vm._s(_vm.loadListStaus))]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }